<template>
  <b-form-group
    label="Versiyon Türü"
    label-for="version_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Versiyon Türü"
      rules="required"
    >
      <v-select
        v-model="dataItem.versionOptions.version_type"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Versiyon Türü"
      />
      <small class="text-danger">{{ errors[0] }}</small>
      <small class="text-secondary"><b>Yeni doküman yükleneceği zaman</b> veya <b>alfa güncellemelerinde</b> değişiklik türü olarak belirtilir.</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'SFilesVOVTSelectCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return [
        {
          id: 'major',
          title: 'Ana Versiyon',
        },
        {
          id: 'minor',
          title: 'Alt Versiyon',
        },
        {
          id: 'patch',
          title: 'Düzeltme',
        },
      ]
    },
    dataItem() {
      return this.$store.getters['serviceFiles/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
